"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ErrorTypography = ErrorTypography;
var _react = _interopRequireDefault(require("react"));
var _material = require("@mui/material");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function ErrorTypography(_ref) {
  var text = _ref.text;
  return /*#__PURE__*/_react["default"].createElement(_material.Typography, {
    variant: "body1",
    component: "h5",
    color: "error",
    align: "center"
  }, text);
}